import { render, staticRenderFns } from "./select-genre.vue?vue&type=template&id=39d8f7bc&"
import script from "./select-genre.vue?vue&type=script&lang=js&"
export * from "./select-genre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oohira/sites/giontsujiri/giontsujiri.co.jp_brand_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39d8f7bc')) {
      api.createRecord('39d8f7bc', component.options)
    } else {
      api.reload('39d8f7bc', component.options)
    }
    module.hot.accept("./select-genre.vue?vue&type=template&id=39d8f7bc&", function () {
      api.rerender('39d8f7bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/store/menus/select-genre.vue"
export default component.exports